<template>
    <SlotContainer :dataLabel="dataLabel">
        <b-row class="gx-0 mb-4">
            <b-col cols="12" class="dd">
                <label class="mb-3" :for="`${dataLabel}-included`"><strong>{{ $translate(`included-${dataLabel}`)
                        }}</strong></label>
                <multiselect v-model="includedData" :options="allowedData" :multiple="true" :close-on-select="false"
                    :clear-on-select="false" :preserve-search="true"
                    :placeholder="$translate(`select-included-${dataLabel}`)" label="name" track-by="id"
                    :preselect-first="true" :deselectLabel="deselectLabel" :selectedLabel="selectedLabel"
                    :selectLabel="selectLabel" :id="`${dataLabel}-included`">
                </multiselect>
            </b-col>
        </b-row>
        <b-row class="gx-0 mb-2" v-if="!includeOnly">
            <b-col cols="12" class="dd">
                <label class="mb-3" :for="`${dataLabel}-excluded`"><strong>{{ $translate(`excluded-${dataLabel}`)
                        }}</strong></label>
                <multiselect v-model="excludedData" :options="allowedData" :multiple="true" :close-on-select="false"
                    :clear-on-select="false" :preserve-search="true"
                    :placeholder="$translate(`select-excluded-${dataLabel}`)" label="name" track-by="id"
                    :preselect-first="true" :deselectLabel="deselectLabel" :selectedLabel="selectedLabel"
                    :selectLabel="selectLabel" :id="`${dataLabel}-excluded`">
                </multiselect>
            </b-col>
        </b-row>
    </SlotContainer>
</template>

<script lang="js">
import Multiselect from 'vue-multiselect'
import SlotContainer from './SlotContainer.vue';


export default {
    name: 'includeExclude',
    components: {
        Multiselect, SlotContainer
    },

    props: {
        modelInclude: {
            type: Array,
            default: () => [],
        },
        modelExclude: {
            type: Array,
            default: () => [],
        },
        allData: {
            type: Array,
            default: () => [],
        },
        includeOnly: {
            type: Boolean,
            default: false
        },
        dataLabel: { type: String, required: true },
    },

    data() {
        return {
            includedData: [],
            excludedData: [],
        }
    },


    computed: {
        selectLabel() {
            return this.$translate('click_to_select')
        },
        deselectLabel() {
            return this.$translate('click_to_remove')
        },
        selectedLabel() {
            return this.$translate('selected')
        },
        allowedData() {
            const { modelInclude, modelExclude } = this;
            const usedData = [...modelInclude, ...modelExclude];
            return this.allData.filter(x => !usedData.some(y => y == x.id))
        },
        parsedIncludedData() {
            const { allData, modelInclude } = this;
            console.log('modelInclude:', { modelInclude, allData });
            return modelInclude.map(id => allData.find(y => y.id == id));
        },
        parsedExcludedData() {
            const { allData, modelExclude, includeOnly } = this;
            return includeOnly ? [] : modelExclude.map(id => allData.find(y => y.id == id));
        },
    },
    watch: {
        parsedIncludedData: {
            handler: function (val, oldVal) {
                this.includedData.length = 0;
                this.includedData.push(...val);
            },
            deep: true,
            immediate: true
        },
        parsedExcludedData: {
            handler: function (val, oldVal) {
                this.excludedData.length = 0;
                this.excludedData.push(...val);
            },
            deep: true,
            immediate: true
        },
        includedData: {
            handler: function (val, oldVal) {
                this.$emit("update:modelInclude", [...val.map(x => x.id)])
            },
            deep: true,
        },
        excludedData: {
            handler: function (val, oldVal) {
                this.$emit("update:modelExclude", [...val.map(x => x.id)])
            },
            deep: true,
        }


    },

    methods: {

    },
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect__tags-wrap {
    display: inline-block;
    height: auto;
}
</style>